export default {
    copyright: 'Derechos de autor 2021- Airclass Responsabilidad Limitada-Tolos los derechos reservados',
    title: 'Bienvenidos de vuelta!',
    phone: 'Número de teléfono',
    psw: 'Contraseña',
    forgot_psw: '¿Olvidaste tu contraseña?',
    login: 'Iniciar sesión',
    sign_up: 'Sign Up',
    or: 'or',
    text: `No tiene cuenta de Airclass?`,
    createText: 'Crear una cuenta',
    codeText: 'Consiga el código',
    text1: `iniciar sesión con una clave`,
    text2: `Iniciar sesión con un cógido de virificación`,
    sendText: 'Reenviar el código',
    sendText1: 'Resolicitar en ',
    second: 's',
    code: 'Código',
    codeText1: `Chequee el mensaje de su móvil`,
    codeText2: 'un código de verificación：',
    required: 'Solicitado',
    pwsText: `La clave debería ser por lo menos 8 letras`,
    pwsText1: `La clave debería no ser más de 20 letras`,
    pwsText2: `La clave no coincide`,
    pwsText4: `Re-ingrese clave`,
    failed: 'está fallado iniciar sesión',
    in: 'en',
    join: 'Unirse a Airclass',
    descText: 'para unirse, tendría que admitir el ',
    descText1: 'acuerdo del usuario ',
    descText2: 'y ',
    descText3: 'la poítica de la privacidad',
    descText4: 'ya tiene una cuenta? ',
    loginText: 'Iniciar sesión',
    nameText: 'Su nombre',
    age: 'Edad',
    ageText: 'Su edad',
    sAge: 'Seleccionar la edad',
    submit: 'Presentar',
    create: 'Crear una cuenta',
    switch_mode: 'Iniciar sesión con {mode}',
    information: 'Información perfecta',
		welcomeSpeech: 'Tu amigo te invita a unirte a AirClass, regístrate ahora y obten una clase de prueba gratuita',
		createPrompt: 'Crear con {type}',
		emailErr: 'Debes ingresar una dirección de correo electrónico válida',
		hasEmail: 'El correo electrónico actual ha sido registrado',
		unregistered: 'El correo electrónico actual no ha sido registrado',
		existEmail: 'El correo electrónico ya está en uso, por favor intente con otro',
		sentEmailBefore: 'El código de autorización ha sido enviado a ',
		sentEmailAfter: '. Por favor revise su correo electrónico.',
		getCode:'Obtener el código',
		resendAgain:'Reenviar de nuevo en ',
		joinAirClass:'Unirse a AirClass',
		esPhone:'teléfono',
		resendCode:'Reenviar código'
}
